import React, { useState, useEffect, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "app/components/Grid/GridItem.js";
import GridContainer from "app/components/Grid/GridContainer.js";
import Button from "app/components/CustomButtons/Button.js";
import Card from "app/components/Card/Card.js";
import CardHeader from "app/components/Card/CardHeader.js";
import CardBody from "app/components/Card/CardBody.js";
import CardFooter from "app/components/Card/CardFooter.js";
import axios from 'axios';
import { Redirect } from 'react-router';
import TextField from '@mui/material/TextField';
import ShipperAddress from "app/components/Address/Shipperaddress.js";
import ShipperAddressAlternative from "app/components/Address/ShipperaddressNotAccountHolder.js";
import ConsigneeAddress from "app/components/Address/Consigneeaddress.js";
import Typography from '@mui/material/Typography';
import AddAddress from "app/components/Address/addaddress.js";
import Autocomplete from '@mui/material/Autocomplete';
import PackagesForm from "app/components/ShipmentPackages/PackagesFormCQuote.js";
import { DatePicker } from '@mui/x-date-pickers';
import { darkBlueColor } from 'app/layout/material-dashboard-react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import CircularProgress from '@mui/material/CircularProgress';
import CustomerAddress from "app/components/Address/CustomerAddress.js";
import { PackageContext } from 'app/context/PackageContext';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { packageValidationHelper } from 'app/helpers/packageValidationHelper';
import { LoginStatusContext } from 'app/context/LoginStatusContext';
import { Grid } from '@mui/material';
import { TransportMode } from 'app/types/enums';
import { AirportAutocomplete } from 'app/components/CustomInput/AirportAutocomplete';
import { PortAutocomplete } from 'app/components/CustomInput/PortAutocomplete';

const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0",
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
    },
};

const useStyles = makeStyles(styles);

export default function ShipmentEdit() {
    const classes = useStyles();

    const [termType, setTermType] = useState([]);
    const [cargoMode, setCargoMode] = useState([]);
    const [terminal, setTerminal] = useState([]);
    const [showPackages, setShowPackages] = useState(false);
    const [shipmentID, setShipmentID] = useState(0);
    const [postTypeShipmentQuote, setPostTypeShipmentQuote] = useState('add');
    const [shipmentRef, setShipmentRef] = useState('');
    const [userAdded, setUserAdded] = useState('');
    const [dateAdded, setDateAdded] = useState();
    const [showQuoteButton, setShowQuoteButton] = useState(true);
    const [showDeleteButton, setShowDeleteButton] = useState(false);
    const [showPortShipper, setShowPortShipper] = useState(false);
    const [showPortDelivery, setShowPortDelivery] = useState(false);
    const [terminalID, setTerminalID] = useState(0);
    const [selectedCargoMode, setSelectedCargoMode] = useState({ id: "", label: "", name: null, countryCode: null });
    const [collectionDate, setCollectionDate] = useState(new Date());
    const [expectedDeliveryDate] = useState(null);
    const [showShipperAlternative, setShowShipperAlternative] = useState(false);
    const [addressShipperID] = useState('');
    const [addressShipperColID] = useState('');
    const [addressConsigneeID] = useState('');
    const [addressConsigneeDelID] = useState('');
    const [bookingType, setBookingType] = useState(undefined);
    const [primaryTransportMode, setPrimaryTransportMode] = useState();
    const [disableBookingType, setDisableBookingType] = useState(false);
    const [pendingQuote, setPendingQuote] = useState(false);
    const [showInsuranceFinancialValue, setShowInsuranceFinancialValue] = useState(false);
    const [insuranceFinancialValue, setInsuranceFinancialValue] = useState('');
    const [selectedTermType, setSelectedTermType] = useState('');
    const [addedPackages, setAddedPackages] = useState([{}]);
    const [quoteResponse, setQuoteResponse] = useState();
    const { history } = useHistory(); 
    const { setIsLoggedIn } = useContext(LoginStatusContext);
    
    useEffect(() => {
        async function validateUserSessionId() {
            try {
                await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/login/ValidateUserSessionId`)
                        .then(() => setIsLoggedIn(true));
                
            } catch (error) {
                setIsLoggedIn(false);
                window.location.replace(`${process.env.PUBLIC_URL}/login`);
            }
        }
        validateUserSessionId();
    }, [setIsLoggedIn]);

    useEffect(() => {
        handleCargoModes();
        handleTermTypes();
    }, []);

    useEffect(() => {
        if (bookingType) {
            setShowPackages(true);
        }
    }, [bookingType])

    const handleTerminalChange = (value) => setTerminalID(value);

    useEffect(() => {
        try {
            const addPackagesToShipment = async () => {
                if (quoteResponse) {
                    await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/api/shipment/AddPackages`, addedPackages, { params: {
                        shipmentId: quoteResponse.shipmentId
                    }
                    }).then((res) => {
                        setPendingQuote(false);
                        if (res.status === 200) {
                        window.location.replace(`/LeoSeaPortal/quotedetails?shipmentId=${quoteResponse.shipmentId}`);
                    }
                });
                }
            }
            addPackagesToShipment();
        } catch (error) {
            if (error.response) {
                console.error(`An error occured whilst saving packages. Status: ${error.response.status}. Detail from server: ${error.response.data.detail}.`);
            }
        }
     }, [addedPackages, history, quoteResponse, shipmentID])

    //On change handle the Term Types request
    const handleTermTypes = () => {
        axios
            .get(`${process.env.REACT_APP_API_ENDPOINT}/api/lookup/GetTermTypes`)
            .then((res) => {
                setTermType(res.data);
            })
            .catch((e) => {
                console.log('error happened');
            });
    };
    //On change handle the termtype selected
    const handlePortPathway = (event, value) => {
        setSelectedTermType(value.id);
        if (value.label.includes("CIF")) {
            setShowPortShipper(false);
            setShowPortDelivery(true);
            setShowShipperAlternative(false);
            setShowInsuranceFinancialValue(true);
        }
        else if (value.label.includes("CFR")) {
            setShowPortShipper(false);
            setShowPortDelivery(true);
            setShowShipperAlternative(false);
            setShowInsuranceFinancialValue(false);
            setInsuranceFinancialValue('');
        }
        else if (value.label.includes("DAP") || value.label.includes("DDP")) {
            setShowPortShipper(false);
            setShowPortDelivery(false);
            setShowShipperAlternative(false);
            setShowInsuranceFinancialValue(false);
            setInsuranceFinancialValue('');
        }
        else if (value.label.includes("FCA")) {
            setShowPortShipper(true);
            setShowPortDelivery(false);
            setShowShipperAlternative(true);
            setShowInsuranceFinancialValue(false);
            setInsuranceFinancialValue('');
        }
        else if (value.label.includes("FOB")) {
            setShowPortShipper(true);
            setShowPortDelivery(false);
            setShowShipperAlternative(false);
            setShowInsuranceFinancialValue(false);
            setInsuranceFinancialValue('');
        }
        else if (value.label.includes("EXW")) {
            setShowPortShipper(false);
            setShowPortDelivery(false);
            setShowShipperAlternative(true);
            setShowInsuranceFinancialValue(false);
            setInsuranceFinancialValue('');
        }
        else {
            setShowPortShipper(false);
            setShowPortDelivery(false);
            setShowShipperAlternative(false);
            setShowInsuranceFinancialValue(false);
            setInsuranceFinancialValue('');
        }
    }

    //On change handle the Cargo Modes request
    const handleCargoModes = (event, value) => {
        setSelectedCargoMode(value);

        axios
            .get(`${process.env.REACT_APP_API_ENDPOINT}/api/lookup/GetCargoModes`)
            .then((res) => {
                setCargoMode(res.data);
            })
            .catch((e) => {
                console.log('error happened');
            });
    };

    function newForm() {
        window.location.reload(true);
    }

    function reset() {
        setPostTypeShipmentQuote("delete");
    }

    const onCollectionDateChange = (date) => {
        setCollectionDate(date);
    };

    const bookingTypeOnChange = (event) => {
        if (event.target.value) {
            setBookingType(event.target.value);
            setPrimaryTransportMode(event.target.value === 20 ? "S" : "A")
            setSelectedCargoMode({});
            setTerminalID('')
        }
    }

    const insuranceFinancialValueOnChange = (event) => {
        if (event.target.value) {
            setInsuranceFinancialValue(event.target.value)
        }
    }

    function packageValidation() {
        var newPackages = packageValidationHelper(addedPackages)
        setAddedPackages(newPackages);

        var failedValidation = newPackages.filter((newPackage) => {
            return newPackage.passValidation === false;
        });

        return failedValidation.length > 0 ? false : true;
    }

    function validation() {
        if (packageValidation()) {
            return true;
        }

        return false;
    }

    //Handle the on submit request to post the shipment 
    const onSubmit = async (e) => {
        e.preventDefault();
        if (!validation()) {
            return;
        }

        setPendingQuote(true);
        
        const form = e.currentTarget;

        const formData = new FormData(form);
        formData.append("postType", postTypeShipmentQuote);
        formData.append("dateAdded", dateAdded);
        formData.append("userAdded", userAdded);
        formData.append("shipmentID", shipmentID);
        formData.append("shipmentRef", shipmentRef);
        formData.append("collectionDate", collectionDate.toLocaleString());
        formData.append("bookingTypeID", bookingType);
        formData.append("primaryTransportMode", primaryTransportMode);
        formData.append("insuranceFinancialValue", insuranceFinancialValue);
        formData.append("homeCostCentreId", sessionStorage.getItem('_HomeCostCentreId'));

        if (expectedDeliveryDate !== null) {
            formData.append("deliveryDate", expectedDeliveryDate.toLocaleString());
        }

        let termType = formData.get('termtype');

        if (termType.includes("CFR") || termType.includes("CIF")) {
            formData.append("sourceTerminalID", 0);
            formData.append("deliveryTerminalID", terminalID)
            setShowPortDelivery(true);
        }
        else if (termType.includes("DAP") || termType.includes("DDP") || termType.includes("EXW")) {
            formData.append("sourceTerminalID", 0);
            formData.append("deliveryTerminalID", 0)
        }
        else if (termType.includes("FCA") || termType.includes("FOB")) {
            formData.append("sourceTerminalID", terminalID);
            formData.append("deliveryTerminalID", 0)
        }
        else {
            formData.append("sourceTerminalID", 0);
            formData.append("deliveryTerminalID", 0)
        }

        let plainFormData = Object.fromEntries(formData.entries());

        if (postTypeShipmentQuote !== 'delete') {
            if (shipmentRef !== '' && shipmentID !== 0) {
                let deleteSet = 'delete';

                if (typeof plainFormData.shipperAddressID !== 'undefined') {
                    if (plainFormData.shipperAddressID !== addressShipperID.toString()) {
                        formData.append("postType", deleteSet);
                        setPostTypeShipmentQuote("delete");
                        plainFormData = Object.fromEntries(formData.entries());
                        return formData;
                    }
                }
                if (typeof plainFormData.consigneeAddressID !== 'undefined') {
                    if (plainFormData.consigneeAddressID !== addressConsigneeID.toString()) {
                        formData.append("postType", deleteSet);
                        setPostTypeShipmentQuote("delete");
                        plainFormData = Object.fromEntries(formData.entries());
                        return formData;
                    }
                }
                if (typeof plainFormData.collectionAddressID !== 'undefined') {
                    if (plainFormData.collectionAddressID !== '0') {
                        if (plainFormData.collectionAddressID !== addressShipperColID.toString()) {
                            formData.append("postType", deleteSet);
                            setPostTypeShipmentQuote("delete");
                            plainFormData = Object.fromEntries(formData.entries());
                            return formData;
                        }
                    }
                }
                if (typeof plainFormData.deliveryAddressID !== 'undefined') {
                    if (plainFormData.deliveryAddressID !== '0') {
                        if (plainFormData.deliveryAddressID !== addressConsigneeDelID.toString()) {
                            formData.append("postType", deleteSet);
                            setPostTypeShipmentQuote("delete");
                            plainFormData = Object.fromEntries(formData.entries());
                            return formData
                        }
                    }
                }
            }
        }

        const formDataJsonString = JSON.stringify(plainFormData);

        await axios
            .post(
                `${process.env.REACT_APP_API_ENDPOINT}/api/shipmentquote`,
                formDataJsonString
            )
            .then(function (response) {
                if (response !== null) {
                    if (response.status === 200) {
                        if (response.data.bookingStatusId === '3') {
                            window.location.replace("/LeoSeaPortal/createquote");
                        }
                        setShipmentID(response.data.shipmentId);
                        setShipmentRef(response.data.shipmentRef);
                        setUserAdded(response.data.userAdded);
                        setDateAdded(response.data.dateAdded);
                        setQuoteResponse(response.data);
                        setShowPackages(true);
                        setPostTypeShipmentQuote('update');
                        setShowQuoteButton(false);
                        setShowDeleteButton(true);
                        setDisableBookingType(true);
                    }
                    if (postTypeShipmentQuote === "delete") {
                        window.location.replace("/LeoSeaPortal/createquote");
                    }
                }
            })
            .catch(function (error) {
                setPendingQuote(false);
                console.log(error);
            });
    };

    return (
        <div style={{ position: 'relative', zIndex: '0' }}>
            <form onSubmit={onSubmit}>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader style={{ backgroundColor: darkBlueColor }}>
                                <h4 className={classes.cardTitleWhite}>Europa Request A Quote {shipmentRef}</h4>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    {bookingType && (
                                        <Grid pr={2} container direction="row" justifyContent="flex-end" alignItems="center">
                                            <AddAddress buttonColour="purple" sectionColour={darkBlueColor}/>
                                        </Grid>
                                        )}
                                    <GridItem xs={12} sm={12}>
                                        <FormControl fullWidth>
                                            <InputLabel id="bookingtype">Booking Type</InputLabel>
                                            <Select
                                                disabled={disableBookingType}
                                                required
                                                labelId="bookingtype"
                                                id="bookingtype"
                                                value={bookingType}
                                                label="Booking Type"
                                                size="small"
                                                sx={{ marginTop: 1 }}
                                                onChange={bookingTypeOnChange}>
                                                <MenuItem value={19}>Air</MenuItem>
                                                <MenuItem value={20}>Sea</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </GridItem>
                                </GridContainer>
                                { bookingType && (
                                    <GridContainer>
                                        <GridItem xs={12} sm={12}>
                                            <Typography variant="h6" gutterBottom component="div" style={{ marginTop: '20px' }}>
                                                Customer
                                            </Typography>
                                        </GridItem>
                                        <GridItem xs={12} sm={12}>
                                            <CustomerAddress />
                                        </GridItem>
                                        <GridItem xs={12} sm={12}>
                                            <Autocomplete
                                                size="small"
                                                disablePortal
                                                id="termtype"
                                                name="termtype"
                                                options={termType}
                                                onInputChange={() => handleTermTypes()}
                                                onChange={handlePortPathway}
                                                sx={{ marginTop: 1 }}
                                                renderInput={(params) => <TextField size="small" {...params} id="termtype" name="termtype" label="Term" required />}
                                            />
                                        </GridItem>
                                        {bookingType === 20 && (
                                            <GridItem xs={12} sm={12}>
                                                <Autocomplete
                                                    size="small"
                                                    disablePortal
                                                    id="cargoMode"
                                                    named="cargoMode"
                                                    options={cargoMode}
                                                    onChange={handleCargoModes}
                                                    sx={{ marginTop: 1 }}
                                                    renderInput={(params) => <TextField size="small" {...params} id="cargoMode" name="cargoMode" label="Cargo Mode" required />} />
                                            </GridItem>
                                        )}
                                        <GridItem xs={12} style={{ marginTop: 20 }}>
                                            <Typography variant="h6" gutterBottom component="div">
                                                Source
                                            </Typography>
                                        </GridItem>
                                        {showShipperAlternative && (<GridItem xs={12}>
                                            <ShipperAddressAlternative/>
                                        </GridItem>)}

                                        {showShipperAlternative && !showShipperAlternative && (<GridItem xs={12}>
                                            <ShipperAddressAlternative/>
                                        </GridItem>)}
                                        {!showPortShipper && !showShipperAlternative && (<GridItem xs={12}>
                                            <ShipperAddress />
                                        </GridItem>)}
                                        {showPortShipper && (<GridItem xs={12}>
                                            {primaryTransportMode === TransportMode.Air ? <AirportAutocomplete onValueChange={handleTerminalChange} /> : <PortAutocomplete onValueChange={handleTerminalChange} />}
                                        </GridItem>)}
                                        <GridItem xs={12} sm={12}>
                                            <DatePicker
                                                id="collectionDate"
                                                name="collectionDate"
                                                label="Ready Date"
                                                value={collectionDate}
                                                onChange={onCollectionDateChange}
                                                renderInput={(params) => <TextField size="small" required fullWidth sx={{ marginTop: 1 }} {...params} />}
                                            />
                                        </GridItem>
                                        <GridItem>
                                            <Typography variant="h6" gutterBottom component="div" style={{ marginTop: '20px' }}>
                                                Destination
                                            </Typography>
                                        </GridItem>
                                        {!showPortDelivery && (<GridItem xs={12}>
                                            <ConsigneeAddress termType={selectedTermType} />
                                        </GridItem>)}
                                        {showPortDelivery && (<GridItem xs={12}>
                                            {primaryTransportMode === TransportMode.Air ? <AirportAutocomplete onValueChange={handleTerminalChange} /> : <PortAutocomplete onValueChange={handleTerminalChange} />}
                                        </GridItem>)}
                                        {showInsuranceFinancialValue && (<>
                                            <GridItem>
                                                <Typography variant="h6" gutterBottom component="div" style={{ marginTop: '20px' }}>
                                                    Insurance
                                                </Typography>
                                            </GridItem>
                                            <GridItem xs={12}>
                                                <TextField
                                                    name="insuranceFinancialValue"
                                                    id="insuranceFinancialValue"
                                                    label="Insurance Financial Value"
                                                    InputLabelProps={{ shrink: true }}
                                                    value={insuranceFinancialValue}
                                                    onChange={insuranceFinancialValueOnChange}
                                                    type="number"
                                                    style={{ marginTop: '10px', width: '100%' }}
                                                    size="small"
                                                    required />
                                            </GridItem></>)
                                        }
                                    </GridContainer>
                                )}
                            </CardBody>
                            <CardFooter>
                                <div>
                                    {showPackages && (<PackageContext.Provider value={{ addedPackages, setAddedPackages }}><PackagesForm backgroundColor={darkBlueColor} shipmentId={shipmentID} cargoMode={selectedCargoMode.id} primaryTransportMode={primaryTransportMode} type="Quote" /></PackageContext.Provider>)}
                                    <Button color="purple" disabled={pendingQuote} type="submit" data-testid="requestAQuoteNextButton">Create Quote</Button>
                                    {pendingQuote && (<CircularProgress style={{ position: 'absolute', marginTop: 5, marginLeft: -80, color: '#FFF' }}></CircularProgress>)}
                                    {bookingType && (<Typography>Once saved you will be unable to edit this quote further</Typography>)}
                                </div>
                            </CardFooter>
                        </Card>
                    </GridItem>
                </GridContainer>
            </form>
        </div>
    );
}